(function () {
  angular.module('cfn').controller('fertilizerCoreController', [
    '$scope',
    '$rootScope',
    'CoreREST',
    'Fertilizer',
    '$http',
    '$timeout',
    '$log',
    '$dialog',
    '$injector',
    '$route',
    'FavoriteService',
    'i18nFilter',
    'farmnet.FeatureToggleService',
    '$q',
    'fertiwebCodeService',
    function (
      $scope,
      $rootScope,
      CoreREST,
      Fertilizer,
      $http,
      $timeout,
      $log,
      $dialog,
      $injector,
      $route,
      FavoriteService,
      i18nFilter,
      featureToggle,
      $q,
      fertiwebCodeService
    ) {
      let mode = {
        name: 'fertilizer',
        hasActive: true,
      };

      let ctrl = this;
      ctrl.getEntityName = function () {
        try {
          return $scope.details.fertilizer.name;
        } catch (e) {
          return '';
        }
      };

      ctrl.getFormulationKey = function () {
        try {
          let i18nFormulation =
            'fe.planning.details.fertilizer.formulation.' +
            ctrl.details.fertilizer.formulation;

          if (
            ctrl &&
            ctrl.details &&
            ctrl.details.fertilizer.formulation === null
          ) {
            return '';
          } else if (i18nFilter(i18nFormulation) !== i18nFormulation) {
            return i18nFilter(i18nFormulation);
            // return 'fe.planning.details.fertilizer.formulation.' + ctrl.details.fertilizer.formulation;
          } else {
            return ctrl.details.fertilizer.formulation;
          }
        } catch (e) {
          return '';
        }
      };

      ctrl.fertiwebCodeOptions = [];
      function fertiwebCodeMappingTableLoaded(response) {
        ctrl.fertiwebCodeOptions = response.data.content;
      }

      ctrl.isFrenchUser = app.credentials.company.countryIsoCode === 'FRA';

      // validation engine
      let vgi = {};
      vgi['active'] = '1';
      vgi['number'] = '1';
      vgi['name'] = '1';
      vgi['tradeName'] = '1';
      vgi['type'] = '1';
      vgi['unit'] = '1';
      vgi['stockyardDisplayUnit'] = '1';
      vgi['formulation'] = '1';
      vgi['density'] = '1';
      vgi['netPrice'] = '2';
      vgi['costs'] = '2';
      vgi['nutrientUnit'] = '3';
      vgi['amountN'] = '3';
      vgi['amountP2O5'] = '3';
      vgi['amountK2O'] = '3';
      vgi['amountMgO'] = '3';
      vgi['amountMg'] = '3';
      vgi['amountCaO'] = '3';
      vgi['amountCa'] = '3';
      vgi['amountS'] = '3';
      vgi['amountMn'] = '3';
      vgi['amountBor'] = '3';
      vgi['amountSe'] = '3';
      vgi['amountCu'] = '3';
      vgi['amountFe'] = '3';
      vgi['amountZn'] = '3';
      vgi['amountNa'] = '3';
      vgi['amountHumus'] = '3';
      vgi['amountNH4'] = '3';
      vgi['amountDrySubstance'] = '3';
      vgi['applyLoss'] = '3';
      vgi['nutrientAvailabilityNYear0'] = '3';
      vgi['nutrientAvailabilityNYear1'] = '3';
      vgi['nutrientAvailabilityNYear2'] = '3';
      vgi['nutrientAvailabilityNYear3'] = '3';
      vgi['nutrientAvailabilityP2O5Year0'] = '3';
      vgi['nutrientAvailabilityP2O5Year1'] = '3';
      vgi['nutrientAvailabilityP2O5Year2'] = '3';
      vgi['nutrientAvailabilityP2O5Year3'] = '3';
      vgi['nutrientAvailabilityK2OYear0'] = '3';
      vgi['nutrientAvailabilityK2OYear1'] = '3';
      vgi['nutrientAvailabilityK2OYear2'] = '3';
      vgi['nutrientAvailabilityK2OYear3'] = '3';
      vgi['nutrientAvailabilityMgOYear0'] = '3';
      vgi['nutrientAvailabilityMgOYear1'] = '3';
      vgi['nutrientAvailabilityMgOYear2'] = '3';
      vgi['nutrientAvailabilityMgOYear3'] = '3';
      vgi['nutrientAvailabilityCaOYear0'] = '3';
      vgi['nutrientAvailabilityCaOYear1'] = '3';
      vgi['nutrientAvailabilityCaOYear2'] = '3';
      vgi['nutrientAvailabilityCaOYear3'] = '3';
      mode.vgi = vgi;

      const buildController = () =>
        coreCommonController(
          'fertilizer',
          ctrl,
          mode,
          $scope,
          $rootScope,
          CoreREST,
          Fertilizer,
          $http,
          $timeout,
          $log,
          $dialog,
          $injector,
          $route,
          FavoriteService,
          i18nFilter
        );

      return ctrl.isFrenchUser
        ? fertiwebCodeService
            .loadMappingTable()
            .then(fertiwebCodeMappingTableLoaded)
            .then(buildController)
        : buildController();
    },
  ]);
})();
